import React from 'react';
import { CheckCircle, Circle } from 'lucide-react';

interface OnboardingProgressProps {
  currentStep: number;
  totalSteps: number;
  steps: {
    title: string;
    completed: boolean;
  }[];
}

const OnboardingProgress: React.FC<OnboardingProgressProps> = ({
  currentStep,
  totalSteps,
  steps,
}) => {
  return (
    <div className="mb-8">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold text-gray-900">
          Step {currentStep} of {totalSteps}
        </h2>
        <span className="text-sm text-gray-500">
          {Math.round((currentStep / totalSteps) * 100)}% Complete
        </span>
      </div>

      <div className="relative">
        {/* Progress bar background */}
        <div className="absolute top-5 left-0 w-full h-1 bg-gray-200 rounded"></div>
        
        {/* Progress bar fill */}
        <div 
          className="absolute top-5 left-0 h-1 bg-blue-600 rounded transition-all duration-300"
          style={{ width: `${(currentStep / totalSteps) * 100}%` }}
        ></div>

        {/* Steps */}
        <div className="relative flex justify-between">
          {steps.map((step, index) => (
            <div
              key={step.title}
              className={`flex flex-col items-center ${
                index + 1 === currentStep
                  ? 'text-blue-600'
                  : step.completed
                  ? 'text-green-600'
                  : 'text-gray-400'
              }`}
            >
              <div className="relative flex items-center justify-center">
                <div className="w-10 h-10 bg-white rounded-full border-2 flex items-center justify-center transition-colors duration-300">
                  {step.completed ? (
                    <CheckCircle className="w-6 h-6" />
                  ) : index + 1 === currentStep ? (
                    <div className="w-3 h-3 bg-blue-600 rounded-full" />
                  ) : (
                    <Circle className="w-6 h-6" />
                  )}
                </div>
              </div>
              <span className="mt-2 text-sm font-medium">{step.title}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OnboardingProgress;